import axios from "axios";

import { extractErrorMessage } from "@/utils/helper";
import { formatApiErrorMessage } from "@/utils/formatApiErrorMessage";
import { showModalToast } from "@int-traderjoes/ui-components-library";

export function handleApiError(
  error: unknown,
  fallbackMessage: string
) {
  

  if(axios.isAxiosError(error) && error.response?.data?.errorDetails && Array.isArray(error.response.data.errorDetails)){
    const errorDetails = error.response.data.errorDetails;
    errorDetails.forEach((detail: any) => {
      if(detail.message){
        showModalToast(formatApiErrorMessage(detail.message));
      }
    });
    return;
  }


  // Use the helper function to extract error message
  let errorMessage = extractErrorMessage(error) || fallbackMessage;
  showModalToast(formatApiErrorMessage(errorMessage));
}